import { getButtonStyles } from '@shared/entity';
import { Stack, Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';

type TabButtonsProps = {
  isPurchaseStockItem: boolean;
  setIsPurchaseStockItem: (v: boolean) => void;
};

export const StockItemTabButtons = ({
  isPurchaseStockItem,
  setIsPurchaseStockItem,
}: TabButtonsProps) => (
  <Stack direction="row" spacing={1} alignItems="center">
    <Button
      id="add-stock-new-item-tab"
      size="small"
      fullWidth
      sx={getButtonStyles(!isPurchaseStockItem)}
      onClick={() => setIsPurchaseStockItem(false)}
    >
      <FormattedMessage id="stockItem.newStockItem" defaultMessage="Nová položka" />
    </Button>
    <Button
      id="add-stock-purchase-item-tab"
      size="small"
      fullWidth
      sx={getButtonStyles(isPurchaseStockItem)}
      onClick={() => setIsPurchaseStockItem(true)}
    >
      <FormattedMessage id="stockItem.purchaseButton" defaultMessage="Nákup položky" />
    </Button>
  </Stack>
);
